import { Capacitor } from '@capacitor/core';
import type { NativeSharedFile } from './secretarioNative.js';

/**
 * O que outro app compartilhou chega como arquivos na pasta temporária do app; aqui eles
 * viram `File` para a conversa (do Secretário ou com uma pessoa). O que não deu para trazer
 * (grande demais, ilegível) volta numa frase curta para a tela avisar.
 */
export async function filesFromNative(
  list: NativeSharedFile[],
): Promise<{ files: File[]; notice: string | null }> {
  const files: File[] = [];
  let skipped = 0;
  let large = false;
  for (const item of list) {
    if (!item.path) {
      skipped += 1;
      if (item.tooLarge) large = true;
      continue;
    }
    try {
      const response = await fetch(Capacitor.convertFileSrc(`file://${item.path}`));
      const blob = await response.blob();
      files.push(new File([blob], item.name || 'arquivo', { type: item.mime || blob.type }));
    } catch {
      skipped += 1;
    }
  }
  const notice = skipped
    ? large
      ? 'Um dos arquivos passa de 20 MB e ficou de fora.'
      : 'Não consegui abrir um dos arquivos.'
    : null;
  return { files, notice };
}
